import React from "react";

interface BlogPostSchemaProps {
  url?: string;           // page url from the CMS entry
  datePublished?: string; // ISO date; also used as dateModified (no separate modified date is authored)
  imageUrl?: string;      // featured image
  seoData: any;           // headline/description — Frontastic Studio page folder SEO settings
  logoUrl: any;
}

/**
 * BlogPosting JSON-LD for renovation-guide articles. Rendered by the legacy renovation-guide tastic
 * (from the `blog_landing_page` entry) and by the V2 master container tastic (from `generic_page_v2`
 * `blog_meta_data`, only when `is_blog_page` is set).
 */
const BlogPostSchema: React.FC<BlogPostSchemaProps> = ({ url, datePublished, imageUrl, seoData, logoUrl }) => {
  const schema = {
    "@context": "http://schema.org",
    "@type": "BlogPosting",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": url,
    },
    "headline": seoData?.title ?? "",
    "description": seoData?.description ?? "",
    "author": {
      "@type": "Organization",
      "name": "Caroma",
    },
    "publisher": {
      "@type": "Organization",
      "name": "Caroma",
      "logo": {
        "@type": "ImageObject",
        "url": logoUrl,
      },
    },
    "datePublished": datePublished ?? "",
    "dateModified": datePublished ?? "",
    "image": imageUrl ?? "",
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};

export default BlogPostSchema;
